export const USER_REQUEST_ACTION_LABELS = {
    ARCHIVE_FOR_SUPERVISORS: 'Archive for Supervisors',
    ARCHIVE_FOR_MYSELF: 'Archive for Myself',
    ACTIVATE_FOR_SUPERVISORS: 'Activate for Supervisors',
    ACTIVATE_FOR_MYSELF: 'Activate for Myself',
} as const;

export const USER_REQUEST_FILTER_LABELS = {
    ARCHIVED_FOR_SUPERVISORS: 'Archived for Supervisors',
    ARCHIVED_FOR_MYSELF: 'Archived for Myself',
} as const;
